import { Schema } from '../create/components/license-form.schema';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { idParamSchema, licenseIdParamSchema } from '~/schemas';
import { LicenseForm } from '../create/components/license-form';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { useUpdateLicenseMutation } from '../mutations';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useLicenseQuery } from '../queries';

export const Page = withPrivateRoute(() => {
  const mutation = useUpdateLicenseMutation();

  const { licenseId } = useParams(licenseIdParamSchema.parse);
  const { id } = useParams(idParamSchema.parse);
  const { data } = useLicenseQuery(licenseId);

  async function onSubmit(data: Schema) {
    return await mutation.mutateAsync({ id: licenseId, person: id, ...data });
  }

  if (!data) {
    return false;
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Redigera licens" />

      <PageLayout.Section>
        <LicenseForm
          defaultValues={{
            ...data,
            club: [data.club!.name, data.club!.id],
            start_date: data.start_date!,
            end_date: data.end_date!,
          }}
          onSubmit={onSubmit}
          isLoading={false}
          mode="edit"
        />
      </PageLayout.Section>
    </Fragment>
  );
});
